import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRadioGroup,_vm._g(_vm._b({class:_vm.customData.class},'v-radio-group',_vm.customData.props,false),_vm.customData.on),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }